import React, { useState, useEffect } from 'react';

const Timer = ({ gameStarted }) => {
    const [seconds, setSeconds] = useState(0);

    useEffect(() => {
      let interval = null;
      if (gameStarted) {
        interval = setInterval(() => {
          setSeconds(prevSeconds => prevSeconds + 1);
        }, 1000);
      } else if (!gameStarted && seconds !== 0) {
        clearInterval(interval);
        setSeconds(0); // Reset timer when game stops
      }
      return () => clearInterval(interval);
    }, [gameStarted, seconds]);
  
    const formatTime = (totalSeconds) => {
      const minutes = Math.floor(totalSeconds / 60);
      const remainingSeconds = totalSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}:${remainingSeconds.toString().padStart(2, '0')}`;
    };

  return (
    <div className="text-2xl font-bold text-purple-300 bg-gray-700 px-4 py-2 rounded-lg shadow-inner">
      Time: {formatTime(seconds)}
    </div>
  );
};

export default Timer;